(function () {
  if (customElements.get("skin-quiz")) return;
  const TOTAL_STEPS = 3;
  const QUIZ_DISCOUNT_CODE = "QUIZ5";
  const QUIZ_DISCOUNT_RATE = 0.05;
  const RESULT_GREETING_FALLBACK = "Com sinceridade,";
  const MIN_RESULT_LOADING_MS = 2800;
  const LOADING_STEP_DURATIONS_MS = [850, 900];

  const STAGE_LABELS = {
    cleanser: "Limpeza",
    niacinamide: "Tratamento",
    moisturizer: "Hidratação",
    exosomes: "Tratamento",
    vitamin_c: "Tratamento",
    sunscreen: "Proteção",
  };

  const ANSWER_LABELS = {
    skin: {
      oleosa: "pele oleosa",
      mista: "pele mista",
      acneica: "pele acneica",
      seca: "pele seca",
    },
    goal: {
      oily_pores: "oleosidade e poros",
      acne_marks: "cravos e acne",
      darkspots: "manchas e marquinhas",
      hydration: "hidratação e conforto",
      prevention: "prevenção de sinais",
      anti_age: "firmeza e sinais de envelhecimento",
      glow: "viço e luminosidade",
    },
    size: {
      "2": "uma rotina essencial de 2 produtos",
      "3": "uma rotina completa de 3 produtos",
    },
  };

  const SKIN_TYPE_LABELS = {
    oleosa: "oleosa",
    mista: "mista",
    acneica: "acneica",
    seca: "seca",
  };

  const RULES = [
    {
      id: "oily-blemish-two-balance",
      skins: ["oleosa", "mista", "acneica"],
      goals: ["oily_pores", "acne_marks"],
      sizes: ["2"],
      title: "Rotina essencial para equilibrar brilho e textura",
      description:
        "Combinamos niacinamida com limpeza para tratar oleosidade, poros e marcas sem pesar a rotina.",
      mainCandidates: ["niacinamide", "cleanser"],
      alternativeCandidates: ["moisturizer", "sunscreen"],
      mainDisplayTitle: "Essencial para controle e equilíbrio",
      alternativeDisplayTitle: "Outra composição leve para começar",
    },
    {
      id: "oily-blemish-two-dry",
      skins: ["seca"],
      goals: ["oily_pores", "acne_marks"],
      sizes: ["2"],
      title: "Rotina essencial para tratar sem sensibilizar",
      description:
        "Mantivemos niacinamida como protagonista e adicionamos hidratação de conforto para peles mais secas.",
      mainCandidates: ["niacinamide", "moisturizer"],
      alternativeCandidates: ["cleanser", "sunscreen"],
      mainDisplayTitle: "Essencial equilibrado e confortável",
      alternativeDisplayTitle: "Outra combinação para esse objetivo",
    },
    {
      id: "oily-blemish-three-balance",
      skins: ["oleosa", "mista", "acneica"],
      goals: ["oily_pores", "acne_marks"],
      sizes: ["3"],
      title: "Rotina completa para controle e tratamento contínuo",
      description:
        "Incluímos limpeza, tratamento e um terceiro passo complementar para manter consistência no dia a dia.",
      mainCandidates: ["cleanser", "niacinamide", "moisturizer"],
      alternativeCandidates: ["sunscreen", "moisturizer"],
      mainDisplayTitle: "Rotina completa de equilíbrio",
      alternativeDisplayTitle: "Outra combinação de 3 passos",
    },
    {
      id: "oily-blemish-three-dry",
      skins: ["seca"],
      goals: ["oily_pores", "acne_marks"],
      sizes: ["3"],
      title: "Rotina completa para tratar com mais conforto",
      description:
        "A composição prioriza tratamento e conforto, finalizando com proteção para sustentar os resultados.",
      mainCandidates: ["niacinamide", "moisturizer", "sunscreen"],
      alternativeCandidates: ["cleanser", "sunscreen"],
      mainDisplayTitle: "Rotina completa com foco em conforto",
      alternativeDisplayTitle: "Outra combinação próxima do seu perfil",
    },
    {
      id: "darkspots-two",
      skins: ["oleosa", "mista", "seca", "acneica"],
      goals: ["darkspots"],
      sizes: ["2"],
      title: "Essencial antimanchas para uniformidade",
      description:
        "Combinamos vitamina C e niacinamida para apoiar luminosidade e tom mais uniforme com constância.",
      mainCandidates: ["vitamin_c", "niacinamide"],
      alternativeCandidates: ["vitamin_c", "niacinamide"],
      mainDisplayTitle: "Duo antimanchas",
      alternativeDisplayTitle: "Outra combinação com ativos complementares",
    },
    {
      id: "darkspots-three",
      skins: ["oleosa", "mista", "seca", "acneica"],
      goals: ["darkspots"],
      sizes: ["3"],
      title: "Rotina completa para manchas e luminosidade",
      description:
        "Para uma rotina de três produtos, priorizamos uma seleção mais completa para uniformizar o tom e manter a pele protegida.",
      mainCandidates: ["vitamin_c", "niacinamide", "sunscreen"],
      alternativeCandidates: ["vitamin_c", "sunscreen"],
      mainDisplayTitle: "Rotina antimanchas",
      alternativeDisplayTitle: "Outra forma de começar esse cuidado",
    },
    {
      id: "hydration-two",
      skins: ["seca", "mista", "oleosa", "acneica"],
      goals: ["hydration"],
      sizes: ["2"],
      title: "Essencial de hidratação e conforto",
      description:
        "O hidratante lidera a composição e o segundo passo adapta o cuidado ao seu momento de pele.",
      mainCandidates: ["moisturizer", "cleanser"],
      alternativeCandidates: ["niacinamide", "sunscreen"],
      mainDisplayTitle: "Dupla de hidratação",
      alternativeDisplayTitle: "Outra forma de manter conforto",
    },
    {
      id: "hydration-three",
      skins: ["seca"],
      goals: ["hydration"],
      sizes: ["3"],
      title: "Rotina completa para pele seca",
      description:
        "Para pele seca, a rotina completa combina conforto, suporte e proteção diária.",
      mainCandidates: ["cleanser", "moisturizer", "sunscreen"],
      alternativeCandidates: ["moisturizer", "cleanser"],
      mainDisplayTitle: "Rotina para pele seca",
      alternativeDisplayTitle: "Outra seleção para manter o conforto",
    },
    {
      id: "hydration-three-balance",
      skins: ["mista", "oleosa", "acneica"],
      goals: ["hydration"],
      sizes: ["3"],
      title: "Rotina completa de hidratação com leveza",
      description:
        "A composição entrega conforto e proteção sem pesar, mantendo a rotina fácil de seguir.",
      mainCandidates: ["moisturizer", "cleanser", "sunscreen"],
      alternativeCandidates: ["niacinamide", "sunscreen"],
      mainDisplayTitle: "Rotina completa de hidratação",
      alternativeDisplayTitle: "Outra combinação para esse cuidado",
    },
    {
      id: "prevention-two",
      skins: ["oleosa", "mista", "seca", "acneica"],
      goals: ["prevention"],
      sizes: ["2"],
      title: "Essencial para prevenção no dia a dia",
      description:
        "Vitamina C lidera a rotina e o segundo passo se adapta ao seu perfil para facilitar consistência.",
      mainCandidates: ["vitamin_c", "sunscreen"],
      alternativeCandidates: ["moisturizer", "sunscreen"],
      mainDisplayTitle: "Duo de prevenção",
      alternativeDisplayTitle: "Outra combinação antioxidante",
    },
    {
      id: "prevention-three",
      skins: ["oleosa", "mista", "seca", "acneica"],
      goals: ["prevention"],
      sizes: ["3"],
      title: "Rotina completa para prevenção consistente",
      description:
        "No formato completo, combinamos antioxidante, hidratação e proteção para um cuidado mais estruturado.",
      mainCandidates: ["vitamin_c", "moisturizer", "sunscreen"],
      alternativeCandidates: ["vitamin_c", "sunscreen"],
      mainDisplayTitle: "Rotina completa de prevenção",
      alternativeDisplayTitle: "Outra combinação preventiva",
    },
    {
      id: "antiage-three",
      skins: ["oleosa", "mista", "seca", "acneica"],
      goals: ["anti_age"],
      sizes: ["3"],
      title: "Rotina completa para firmeza e renovação",
      description:
        "Quando a meta é cuidar de firmeza e sinais de envelhecimento, uma rotina completa costuma fazer mais sentido.",
      mainCandidates: ["exosomes", "moisturizer", "sunscreen"],
      alternativeCandidates: ["exosomes", "moisturizer"],
      mainDisplayTitle: "Rotina para firmeza e renovação",
      alternativeDisplayTitle: "Outro caminho para começar esse cuidado",
    },
    {
      id: "antiage-default",
      skins: ["oleosa", "mista", "seca", "acneica"],
      goals: ["anti_age"],
      sizes: ["2"],
      title: "Rotina direcionada para firmeza e renovação",
      description:
        "Mesmo em uma rotina mais enxuta, priorizamos produtos que entregam tratamento com leitura clara e uso descomplicado.",
      mainCandidates: ["exosomes", "moisturizer"],
      alternativeCandidates: ["moisturizer", "sunscreen"],
      mainDisplayTitle: "Tratamento focado em firmeza",
      alternativeDisplayTitle: "Outra forma de complementar a rotina",
    },
    {
      id: "glow-two-balance",
      skins: ["oleosa", "mista"],
      goals: ["glow"],
      sizes: ["2"],
      title: "Essencial para glow com acabamento leve",
      description:
        "Vitamina C em destaque com proteção para manter viço no dia a dia com sensação leve.",
      mainCandidates: ["vitamin_c", "sunscreen"],
      alternativeCandidates: ["moisturizer", "sunscreen"],
      mainDisplayTitle: "Dupla para glow diário",
      alternativeDisplayTitle: "Outra combinação para brilho saudável",
    },
    {
      id: "glow-two-comfort",
      skins: ["seca", "acneica"],
      goals: ["glow"],
      sizes: ["2"],
      title: "Essencial para glow com conforto",
      description:
        "A combinação traz luminosidade com apoio de hidratação para uma rotina mais confortável.",
      mainCandidates: ["vitamin_c", "moisturizer"],
      alternativeCandidates: ["sunscreen", "moisturizer"],
      mainDisplayTitle: "Dupla glow com conforto",
      alternativeDisplayTitle: "Outra combinação para manter o viço",
    },
    {
      id: "glow-three-balance",
      skins: ["oleosa", "mista", "seca", "acneica"],
      goals: ["glow"],
      sizes: ["3"],
      title: "Rotina completa para viço e uniformidade",
      description:
        "No formato completo, o terceiro passo complementa a luminosidade para deixar o resultado mais consistente.",
      mainCandidates: ["vitamin_c", "moisturizer", "niacinamide"],
      alternativeCandidates: ["sunscreen", "niacinamide"],
      mainDisplayTitle: "Rotina completa para luminosidade",
      alternativeDisplayTitle: "Outro caminho para manter o viço",
    },
    {
      id: "fallback",
      skins: ["oleosa", "mista", "seca", "acneica"],
      goals: ["oily_pores", "acne_marks", "darkspots", "hydration", "prevention", "anti_age", "glow"],
      sizes: ["2", "3"],
      title: "Uma rotina Sincere para começar bem",
      description:
        "Montamos uma combinação versátil, prática e fácil de ajustar para deixar a sua escolha mais simples.",
      mainCandidates: ["niacinamide", "moisturizer", "sunscreen"],
      alternativeCandidates: ["sunscreen", "vitamin_c"],
      mainDisplayTitle: "Rotina Sincere recomendada",
      alternativeDisplayTitle: "Outra opção próxima do seu resultado",
    },
  ];

  function dedupeKeys(keys) {
    return [...new Set((keys || []).filter(Boolean))];
  }

  function parseMoneyString(value) {
    if (!value) return 0;

    const normalized = String(value)
      .replace(/[^\d,.-]/g, "")
      .replace(/\./g, "")
      .replace(",", ".");

    const amount = Number(normalized);
    return Number.isFinite(amount) ? amount : 0;
  }

  function formatMoney(value) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value || 0);
  }

  function getRoutineItemCopy(productKey) {
    const copyTable = {
      cleanser: "Prepara a pele.",
      niacinamide: "Equilibra brilho e textura.",
      vitamin_c: "Ilumina e uniformiza.",
      exosomes: "Foco em firmeza.",
      moisturizer: "Mantém conforto.",
      sunscreen: "Proteção diária.",
    };

    return copyTable[productKey] || "Complementa sua rotina.";
  }

  function sortRoutineProducts(products) {
    const productOrder = {
      cleanser: 1,
      niacinamide: 2,
      vitamin_c: 2,
      exosomes: 2,
      moisturizer: 3,
      sunscreen: 4,
    };

    return [...products].sort((a, b) => (productOrder[a.key] || 99) - (productOrder[b.key] || 99));
  }

  function getRoutineStepTitle(productKey) {
    const stepTitleTable = {
      cleanser: "Limpar",
      niacinamide: "Equilibrar",
      vitamin_c: "Tratar",
      exosomes: "Tratar",
      moisturizer: "Hidratar",
      sunscreen: "Proteger",
    };

    return stepTitleTable[productKey] || STAGE_LABELS[productKey] || "Cuidar";
  }

  const INDIVIDUAL_PRODUCT_KEYS = ["cleanser", "niacinamide", "vitamin_c", "exosomes", "moisturizer", "sunscreen"];

  function pickRoutineKeys(state) {
    const table = {
      oily_pores: {
        oleosa: {
          "2": ["niacinamide", "cleanser"],
          "3": ["niacinamide", "cleanser", "sunscreen"],
        },
        mista: {
          "2": ["niacinamide", "cleanser"],
          "3": ["niacinamide", "cleanser", "moisturizer"],
        },
        acneica: {
          "2": ["niacinamide", "cleanser"],
          "3": ["niacinamide", "cleanser", "moisturizer"],
        },
        seca: {
          "2": ["niacinamide", "moisturizer"],
          "3": ["niacinamide", "moisturizer", "sunscreen"],
        },
      },
      acne_marks: {
        oleosa: {
          "2": ["niacinamide", "cleanser"],
          "3": ["niacinamide", "cleanser", "moisturizer"],
        },
        mista: {
          "2": ["niacinamide", "cleanser"],
          "3": ["niacinamide", "cleanser", "moisturizer"],
        },
        acneica: {
          "2": ["niacinamide", "cleanser"],
          "3": ["niacinamide", "cleanser", "moisturizer"],
        },
        seca: {
          "2": ["niacinamide", "moisturizer"],
          "3": ["niacinamide", "moisturizer", "sunscreen"],
        },
      },
      darkspots: {
        oleosa: {
          "2": ["vitamin_c", "niacinamide"],
          "3": ["vitamin_c", "niacinamide", "sunscreen"],
        },
        mista: {
          "2": ["vitamin_c", "niacinamide"],
          "3": ["vitamin_c", "niacinamide", "sunscreen"],
        },
        acneica: {
          "2": ["vitamin_c", "niacinamide"],
          "3": ["vitamin_c", "niacinamide", "sunscreen"],
        },
        seca: {
          "2": ["vitamin_c", "niacinamide"],
          "3": ["vitamin_c", "niacinamide", "sunscreen"],
        },
      },
      hydration: {
        oleosa: {
          "2": ["moisturizer", "niacinamide"],
          "3": ["moisturizer", "niacinamide", "sunscreen"],
        },
        mista: {
          "2": ["moisturizer", "cleanser"],
          "3": ["moisturizer", "cleanser", "sunscreen"],
        },
        acneica: {
          "2": ["moisturizer", "cleanser"],
          "3": ["moisturizer", "cleanser", "sunscreen"],
        },
        seca: {
          "2": ["moisturizer", "cleanser"],
          "3": ["moisturizer", "cleanser", "sunscreen"],
        },
      },
      prevention: {
        oleosa: {
          "2": ["vitamin_c", "sunscreen"],
          "3": ["vitamin_c", "sunscreen", "moisturizer"],
        },
        mista: {
          "2": ["vitamin_c", "sunscreen"],
          "3": ["vitamin_c", "sunscreen", "moisturizer"],
        },
        acneica: {
          "2": ["vitamin_c", "moisturizer"],
          "3": ["vitamin_c", "moisturizer", "sunscreen"],
        },
        seca: {
          "2": ["vitamin_c", "moisturizer"],
          "3": ["vitamin_c", "moisturizer", "sunscreen"],
        },
      },
      anti_age: {
        oleosa: {
          "2": ["exosomes", "moisturizer"],
          "3": ["exosomes", "moisturizer", "sunscreen"],
        },
        mista: {
          "2": ["exosomes", "moisturizer"],
          "3": ["exosomes", "moisturizer", "sunscreen"],
        },
        acneica: {
          "2": ["exosomes", "moisturizer"],
          "3": ["exosomes", "moisturizer", "sunscreen"],
        },
        seca: {
          "2": ["exosomes", "moisturizer"],
          "3": ["exosomes", "moisturizer", "sunscreen"],
        },
      },
      glow: {
        oleosa: {
          "2": ["vitamin_c", "sunscreen"],
          "3": ["vitamin_c", "sunscreen", "niacinamide"],
        },
        mista: {
          "2": ["vitamin_c", "sunscreen"],
          "3": ["vitamin_c", "sunscreen", "niacinamide"],
        },
        acneica: {
          "2": ["vitamin_c", "moisturizer"],
          "3": ["vitamin_c", "moisturizer", "niacinamide"],
        },
        seca: {
          "2": ["vitamin_c", "moisturizer"],
          "3": ["vitamin_c", "moisturizer", "sunscreen"],
        },
      },
    };

    const byGoal = table[state.goal] || table.prevention;
    const bySkin = byGoal[state.skin] || byGoal.mista || byGoal.oleosa;
    const size = state.size === "3" ? "3" : "2";
    return dedupeKeys(bySkin[size] || bySkin["2"] || []);
  }

  function resolveRoutineProducts(state, catalog) {
    const minimumCount = state.size === "3" ? 3 : 2;
    const preferredKeys = pickRoutineKeys(state);
    const fallbackKeys =
      minimumCount === 3
        ? ["cleanser", "niacinamide", "moisturizer", "sunscreen", "vitamin_c", "exosomes"]
        : ["niacinamide", "moisturizer", "cleanser", "vitamin_c", "sunscreen", "exosomes"];
    const candidateKeys = dedupeKeys([...preferredKeys, ...fallbackKeys]);

    const resolved = [];
    const seen = new Set();

    candidateKeys.forEach((key) => {
      const entry = catalog[key];
      if (!entry || entry.type !== "product" || seen.has(entry.key)) return;
      if (!INDIVIDUAL_PRODUCT_KEYS.includes(entry.key)) return;
      seen.add(entry.key);
      resolved.push(entry);
    });

    return resolved.slice(0, minimumCount);
  }

  function buildExplanation(state) {
    const skinLabel = ANSWER_LABELS.skin[state.skin] || "pele";
    const goalLabel = ANSWER_LABELS.goal[state.goal] || "sua prioridade";
    return `Já ajudamos milhares de pessoas com ${skinLabel} melhorando ${goalLabel} na pele.`;
  }

  function buildMainRecommendationLabel(template, skinType) {
    const resolvedTemplate = template || "recomendação principal para pele ${tipo de pele}";
    const skinLabel = SKIN_TYPE_LABELS[skinType] || "";
    if (!skinLabel) return resolvedTemplate.replace(/\$\{\s*tipo de pele\s*\}/gi, "").replace(/\s+/g, " ").trim();
    return resolvedTemplate.replace(/\$\{\s*tipo de pele\s*\}/gi, skinLabel);
  }

  function getCartSectionsString() {
    if (typeof HELPER_UTIL === "undefined" || typeof HELPER_UTIL.sectionRenderUtil !== "function") return "";
    const renderer = HELPER_UTIL.sectionRenderUtil("cart-drawer");
    return renderer && typeof renderer.getSectionsString === "function" ? renderer.getSectionsString() : "";
  }

  function dispatchCartDrawerUpdate(source, sections) {
    if (typeof _EVENT_HELPER === "undefined" || typeof HELPER_UTIL === "undefined") return;

    if (sections) {
      HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerCartChange, source || document, { sections });
      return;
    }

    HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.updateAndShowCart, source || document, {});
  }

  class SkinQuiz extends HTMLElement {
    constructor() {
      super();
      this.state = { skin: null, goal: null, size: null };
    }

    connectedCallback() {
      this.config = this.readConfig();
      this.catalog = this.config.catalog || {};
      this.copy = this.config.copy || {};

      this.progressFill = this.querySelector("[data-progress-fill]");
      this.progressStep = this.querySelector("[data-progress-step]");
      this.introScreen = this.querySelector('[data-screen="intro"]');
      this.flowScreen = this.querySelector('[data-screen="flow"]');
      this.loadingScreen = this.querySelector('[data-screen="loading"]');
      this.resultScreen = this.querySelector('[data-screen="result"]');
      this.consentCheckbox = this.querySelector("[data-consent-checkbox]");
      this.startButton = this.querySelector('[data-action="start"]');
      this.stepButtons = {
        1: this.querySelector('[data-action="next"][data-next-step="2"]'),
        2: this.querySelector('[data-action="next"][data-next-step="3"]'),
        3: this.querySelector('[data-action="finish"]'),
      };

      this.step2Context = this.querySelector("[data-step2-context]");
      this.step2ContextSkin = this.querySelector("[data-step2-context-skin]");
      this.step3Context = this.querySelector("[data-step3-context]");
      this.step3ContextSkin = this.querySelector("[data-step3-context-skin]");
      this.step3ContextGoal = this.querySelector("[data-step3-context-goal]");

      this.resultGreeting = this.querySelector("[data-result-greeting]");
      this.resultBadge = this.querySelector("[data-result-badge]");
      this.resultMainLabel = this.querySelector("[data-result-main-label]");
      this.resultTitle = this.querySelector("[data-result-title]");
      this.resultDescription = this.querySelector("[data-result-description]");
      this.resultTotalOriginal = this.querySelector("[data-routine-total-original]");
      this.resultTotal = this.querySelector("[data-routine-total]");
      this.resultDiscountBadge = this.querySelector("[data-routine-discount-badge]");
      this.resultHelper = this.querySelector("[data-routine-helper]");
      this.addAllButton = this.querySelector('[data-action="add-all"]');
      this.adjustLink = this.querySelector("[data-adjust-link]");

      this.routineContainer = this.querySelector("[data-routine-products]");
      this.routineEmpty = this.querySelector("[data-routine-empty]");
      this.stageTemplate = this.querySelector("[data-routine-stage-template]");
      this.itemTemplate = this.querySelector("[data-routine-item-template]");
      this.loadingSteps = Array.from(this.querySelectorAll("[data-loading-step]"));
      this.loadingTickTimers = [];
      this.loadingTransitionToken = null;

      this.bindEvents();
      this.hardenInternalAdjustControls();
      this.updateConsentState();
      this.updateStepButtons();
      this.showIntro();
    }

    disconnectedCallback() {
      this.stopLoadingTick();
      this.loadingTransitionToken = null;
    }

    readConfig() {
      const script = this.querySelector("[data-skin-quiz-config]");
      if (!script) return { catalog: {}, copy: {} };

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error("Skin quiz config parse error", error);
        return { catalog: {}, copy: {} };
      }
    }

    bindEvents() {
      this.consentCheckbox?.addEventListener("change", () => this.updateConsentState());

      this.addEventListener("click", (event) => {
        const option = event.target.closest(".skin-quiz__option");
        if (option) {
          this.handleOption(option);
          return;
        }

        const trigger = event.target.closest("[data-action]");
        if (!trigger) return;

        const action = trigger.dataset.action;

        if (action === "edit-size") {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          this.editRoutineComposition();
          return;
        }

        if (action === "start") {
          this.showFlow();
          this.showStep(1);
        }
        if (action === "next") this.showStep(Number(trigger.dataset.nextStep));
        if (action === "back") this.showStep(Number(trigger.dataset.backStep));
        if (action === "finish") this.finishQuiz();
        if (action === "restart") this.restartQuiz();
        if (action === "add-all") this.addAllRoutineProducts(trigger);
        if (action === "remove-routine-item") this.removeRoutineItem(trigger);
      });
    }

    hardenInternalAdjustControls() {
      if (!this.adjustLink) return;

      // Defensive: if old markup renders as <a>, force internal action semantics.
      if (this.adjustLink.tagName === "A") {
        this.adjustLink.removeAttribute("href");
        this.adjustLink.setAttribute("role", "button");
      }

      this.adjustLink.setAttribute("data-action", "edit-size");
    }

    handleOption(option) {
      const field = option.dataset.field;
      const value = option.dataset.value;
      if (!field || !value) return;

      const scope = option.closest(".skin-quiz__options");
      scope?.querySelectorAll(`.skin-quiz__option[data-field="${field}"]`).forEach((item) => {
        item.classList.remove("is-selected");
        item.setAttribute("aria-pressed", "false");
      });

      option.classList.add("is-selected");
      option.setAttribute("aria-pressed", "true");
      this.state[field] = value;
      this.updateStepButtons();
      this.updateStepContext();
    }

    updateStepButtons() {
      const consentMissing = this.consentCheckbox ? !this.consentCheckbox.checked : false;
      if (this.startButton) this.startButton.disabled = consentMissing;
      if (this.stepButtons[1]) this.stepButtons[1].disabled = !this.state.skin;
      if (this.stepButtons[2]) this.stepButtons[2].disabled = !this.state.goal;
      if (this.stepButtons[3]) this.stepButtons[3].disabled = !this.state.size;
    }

    updateConsentState() {
      this.updateStepButtons();
    }

    showIntro() {
      this.introScreen.hidden = false;
      this.flowScreen.hidden = true;
      if (this.loadingScreen) this.loadingScreen.hidden = true;
      this.resultScreen.hidden = true;
      this.stopLoadingTick();
    }

    showFlow() {
      this.introScreen.hidden = true;
      this.flowScreen.hidden = false;
      if (this.loadingScreen) this.loadingScreen.hidden = true;
      this.resultScreen.hidden = true;
      this.stopLoadingTick();
    }

    showLoading() {
      this.introScreen.hidden = true;
      this.flowScreen.hidden = true;
      if (this.loadingScreen) this.loadingScreen.hidden = false;
      this.resultScreen.hidden = true;
      this.startLoadingTick();
    }

    showResult() {
      this.introScreen.hidden = true;
      this.flowScreen.hidden = true;
      if (this.loadingScreen) this.loadingScreen.hidden = true;
      this.resultScreen.hidden = false;
      this.stopLoadingTick();
    }

    startLoadingTick() {
      this.stopLoadingTick();
      if (!this.loadingSteps.length) return;

      const activateStep = (activeIndex) => {
        this.loadingSteps.forEach((item, index) => {
          item.classList.toggle("is-active", index === activeIndex);
        });
      };

      activateStep(0);

      LOADING_STEP_DURATIONS_MS.forEach((delay, index) => {
        const timerId = window.setTimeout(() => {
          const nextStep = Math.min(index + 1, this.loadingSteps.length - 1);
          activateStep(nextStep);
        }, LOADING_STEP_DURATIONS_MS.slice(0, index + 1).reduce((sum, value) => sum + value, 0));
        this.loadingTickTimers.push(timerId);
      });
    }

    stopLoadingTick() {
      if (!this.loadingTickTimers?.length) return;
      this.loadingTickTimers.forEach((timerId) => clearTimeout(timerId));
      this.loadingTickTimers = [];
    }

    showStep(stepNumber) {
      this.querySelectorAll(".skin-quiz__step").forEach((step) => {
        const active = Number(step.dataset.step) === stepNumber;
        step.hidden = !active;
      });

      if (this.progressFill) this.progressFill.style.width = `${(stepNumber / TOTAL_STEPS) * 100}%`;
      if (this.progressStep) this.progressStep.textContent = String(stepNumber);
      this.updateStepContext();
    }

    updateStepContext() {
      const skinLabel = this.state.skin ? ANSWER_LABELS.skin[this.state.skin] : "";
      const goalLabel = this.state.goal ? ANSWER_LABELS.goal[this.state.goal] : "";

      if (this.step2Context && this.step2ContextSkin) {
        if (skinLabel) {
          this.step2ContextSkin.hidden = false;
          this.step2ContextSkin.textContent = skinLabel;
        } else {
          this.step2ContextSkin.hidden = true;
          this.step2ContextSkin.textContent = "";
        }

        this.step2Context.hidden = !skinLabel;
      }

      if (this.step3Context && this.step3ContextSkin && this.step3ContextGoal) {
        if (skinLabel) {
          this.step3ContextSkin.hidden = false;
          this.step3ContextSkin.textContent = skinLabel;
        } else {
          this.step3ContextSkin.hidden = true;
          this.step3ContextSkin.textContent = "";
        }

        if (goalLabel) {
          this.step3ContextGoal.hidden = false;
          this.step3ContextGoal.textContent = goalLabel;
        } else {
          this.step3ContextGoal.hidden = true;
          this.step3ContextGoal.textContent = "";
        }

        this.step3Context.hidden = !skinLabel && !goalLabel;
      }
    }

    findRule() {
      return RULES.find(
        (rule) =>
          rule.skins.includes(this.state.skin) &&
          rule.goals.includes(this.state.goal) &&
          rule.sizes.includes(this.state.size)
      );
    }

    async finishQuiz() {
      const rule = this.findRule() || RULES[RULES.length - 1];
      const routineProducts = resolveRoutineProducts(this.state, this.catalog);
      const token = Symbol("loading-transition");
      this.loadingTransitionToken = token;
      const loadingStartAt = performance.now();

      this.currentRule = rule;
      this.currentRoutineProducts = routineProducts;
      this.showLoading();

      this.renderResult();

      await new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
      });

      const elapsed = performance.now() - loadingStartAt;
      const remaining = Math.max(0, MIN_RESULT_LOADING_MS - elapsed);
      if (remaining > 0) {
        await new Promise((resolve) => setTimeout(resolve, remaining));
      }

      if (this.loadingTransitionToken !== token) return;
      this.showResult();
    }

    renderResult() {
      if (this.resultGreeting) {
        this.resultGreeting.hidden = false;
        this.resultGreeting.textContent = RESULT_GREETING_FALLBACK;
        this.resultGreeting.dataset.greetingType = "fallback";
      }

      if (this.resultBadge) {
        const badgeLabel = this.copy.resultBadge || "sua rotina sincere";
        this.resultBadge.hidden = !badgeLabel;
        this.resultBadge.textContent = badgeLabel;
      }

      if (this.resultMainLabel) {
        const label = buildMainRecommendationLabel(this.copy.mainLabel, this.state.skin);
        this.resultMainLabel.hidden = !label;
        this.resultMainLabel.textContent = label;
      }

      if (this.resultTitle) this.resultTitle.textContent = "Essa seria a rotina ideal para sua pele";
      if (this.resultDescription) this.resultDescription.textContent = buildExplanation(this.state);

      this.renderRoutineProducts();
      this.updateConversionBlock();
    }

    renderRoutineProducts() {
      if (!this.routineContainer || !this.stageTemplate || !this.itemTemplate) return;

      this.routineContainer.innerHTML = "";
      const routineProducts = sortRoutineProducts(this.currentRoutineProducts || []);

      if (!routineProducts.length) {
        if (this.routineEmpty) this.routineEmpty.hidden = false;
        return;
      }

      if (this.routineEmpty) this.routineEmpty.hidden = true;

      routineProducts.forEach((product, stageIndex) => {
        const stageNode = this.stageTemplate.content.firstElementChild.cloneNode(true);
        stageNode.querySelector("[data-routine-stage-index]").textContent = String(stageIndex + 1);
        stageNode.querySelector("[data-routine-stage-title]").textContent = getRoutineStepTitle(product.key);

        const itemsContainer = stageNode.querySelector("[data-routine-stage-items]");
        const itemNode = this.itemTemplate.content.firstElementChild.cloneNode(true);
        const imageLink = itemNode.querySelector("[data-routine-item-link]");
        const titleLink = itemNode.querySelector("[data-routine-item-title-link]");
        const image = itemNode.querySelector("[data-routine-item-image]");
        const role = itemNode.querySelector("[data-routine-item-role]");
        const price = itemNode.querySelector("[data-routine-item-price]");
        const removeButton = itemNode.querySelector('[data-action="remove-routine-item"]');

        const productUrl = product.url || "#";
        imageLink.href = productUrl;
        titleLink.href = productUrl;
        titleLink.textContent = product.title || "Produto";
        role.textContent = getRoutineItemCopy(product.key);
        price.textContent = product.price || "";
        removeButton.dataset.productKey = product.key || "";

        if (product.image) {
          image.src = product.image;
          image.alt = product.title || "Produto da rotina";
        } else {
          image.remove();
        }

        itemsContainer.appendChild(itemNode);

        this.routineContainer.appendChild(stageNode);
      });
    }

    updateConversionBlock() {
      const routineProducts = this.currentRoutineProducts || [];
      const totalValue = routineProducts.reduce((sum, product) => sum + parseMoneyString(product.price), 0);
      const discountedValue = Number((totalValue * (1 - QUIZ_DISCOUNT_RATE)).toFixed(2));
      const addable = routineProducts.filter((product) => product.available && product.variantId);
      const adjustLabel = this.copy.adjustLabel || "Ajustar esta rotina";
      const addAllLabel = this.copy.addAllLabel || "adicionar rotina completa ao carrinho";

      if (this.resultTotalOriginal) {
        this.resultTotalOriginal.hidden = totalValue <= 0;
        this.resultTotalOriginal.textContent = formatMoney(totalValue);
      }
      if (this.resultTotal) this.resultTotal.textContent = formatMoney(discountedValue);
      if (this.resultDiscountBadge) this.resultDiscountBadge.hidden = totalValue <= 0;
      if (this.resultHelper) {
        this.resultHelper.textContent = `Cupom ${QUIZ_DISCOUNT_CODE} aplicado automaticamente.`;
      }

      if (this.addAllButton) {
        if (addable.length > 0) {
          this.addAllButton.hidden = false;
          this.addAllButton.dataset.variantIds = addable.map((product) => product.variantId).join(",");
          this.addAllButton.textContent = addAllLabel;
        } else {
          this.addAllButton.hidden = true;
          this.addAllButton.removeAttribute("data-variant-ids");
        }
      }

      if (this.adjustLink) {
        if (routineProducts.length > 0) {
          this.adjustLink.hidden = false;
          this.adjustLink.textContent = adjustLabel;
        } else {
          this.adjustLink.hidden = true;
        }
      }
    }

    editRoutineComposition() {
      this.showFlow();
      this.showStep(3);
      this.updateStepButtons();
      this.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    async applyQuizDiscount(code) {
      if (!code) return false;
      const normalizedCode = String(code).trim().toUpperCase();
      if (!normalizedCode) return false;
      if (this.appliedDiscountCode === normalizedCode) return true;

      const root = window.Shopify?.routes?.root || "/";
      const updateUrl = `${root}cart/update.js`;
      try {
        const updateResponse = await fetch(updateUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ discount: normalizedCode }),
        });
        if (updateResponse.ok) {
          const cart = await updateResponse.json().catch(() => ({}));
          if (this.cartHasDiscountCode(cart, normalizedCode)) {
            this.appliedDiscountCode = normalizedCode;
            return true;
          }
        }
      } catch (_) {}

      try {
        const discountUrl = `${root}discount/${encodeURIComponent(normalizedCode)}?redirect=${encodeURIComponent(
          `${root}cart.js`
        )}`;
        await fetch(discountUrl, {
          method: "GET",
          credentials: "same-origin",
          redirect: "follow",
        });
        const cart = await this.fetchCartState();
        if (this.cartHasDiscountCode(cart, normalizedCode)) {
          this.appliedDiscountCode = normalizedCode;
          return true;
        }
      } catch (_) {}

      return false;
    }

    cartHasDiscountCode(cart, code) {
      if (!cart || !code) return false;
      const normalizedCode = String(code).trim().toUpperCase();
      const discountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      const hasCodeInList = discountCodes.some((entry) =>
        String(entry?.code || entry || "")
          .trim()
          .toUpperCase()
          .includes(normalizedCode)
      );
      if (hasCodeInList) return true;

      const applications = [
        ...(Array.isArray(cart.discount_applications) ? cart.discount_applications : []),
        ...(Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []),
      ];

      return applications.some((application) => {
        const labels = [application?.code, application?.title, application?.description];
        return labels.some((label) => String(label || "").trim().toUpperCase().includes(normalizedCode));
      });
    }

    async fetchCartState() {
      const root = window.Shopify?.routes?.root || "/";
      try {
        const response = await fetch(`${root}cart.js`, {
          method: "GET",
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        if (!response.ok) return null;
        return response.json().catch(() => null);
      } catch (_) {
        return null;
      }
    }

    async addAllRoutineProducts(trigger) {
      const variantIds = [
        ...new Set(
          (trigger.dataset.variantIds || "")
            .split(",")
            .map((value) => Number(value))
            .filter(Boolean)
        ),
      ];

      if (!variantIds.length) return;

      trigger.disabled = true;

      try {
        const sectionsToRender = getCartSectionsString();
        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js${sectionsToRender ? `?sections=${sectionsToRender}` : ""}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: variantIds.map((id) => ({ id, quantity: 1 })) }),
          }
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.description ||
              this.copy.addErrorLabel ||
              "Não foi possível adicionar a rotina ao carrinho."
          );
        }

        const data = await response.json().catch(() => ({}));
        const hasDiscount = await this.applyQuizDiscount(QUIZ_DISCOUNT_CODE);
        if (hasDiscount) {
          dispatchCartDrawerUpdate(trigger);
        } else {
          dispatchCartDrawerUpdate(trigger, data.sections);
        }
      } catch (error) {
        console.error("Skin quiz add all failed", error);
        window.alert(
          error.message ||
            this.copy.addErrorLabel ||
            "Não foi possível adicionar a rotina ao carrinho."
        );
      } finally {
        trigger.disabled = false;
      }
    }

    restartQuiz() {
      this.loadingTransitionToken = null;
      this.state = { skin: null, goal: null, size: null };
      this.currentRule = null;
      this.currentRoutineProducts = [];

      this.querySelectorAll(".skin-quiz__option").forEach((option) => {
        option.classList.remove("is-selected");
        option.setAttribute("aria-pressed", "false");
      });

      this.updateStepButtons();
      this.showFlow();
      this.showStep(1);
    }

    removeRoutineItem(trigger) {
      const productKey = trigger.dataset.productKey;
      if (!productKey || !Array.isArray(this.currentRoutineProducts)) return;

      this.currentRoutineProducts = this.currentRoutineProducts.filter((product) => product.key !== productKey);
      this.renderResult();
    }
  }

  customElements.define("skin-quiz", SkinQuiz);
})();
